export default __webpack_public_path__ + "static/media/phone-lp.fc0bd379.png";